import { RemovePillData } from '@shared/interfaces';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { FilterPill } from './table-filter-pill.class';

export class DateRangeFilter extends FilterPill {
    private composeFilterPillsDateRangeValues(dateRange: Date[] | undefined) {
        if (dateRange?.length !== 2) {
            return [];
        }
        return [
            {
                label: moment(dateRange[0]).format('MM/DD/YYYY') + '-' + moment(dateRange[1]).format('MM/DD/YYYY'),
                value: -1,
            },
        ];
    }

    private removeDateRangeFilter(data: RemovePillData, dateRangeFilter: Date[] | undefined): Date[] | undefined {
        if (data.removeAll) {
            return undefined;
        }

        return dateRangeFilter;
    }

    override updateState(dateFilterValues: Date[] | undefined, debounce?: Subject<void>) {
        this.values = this.composeFilterPillsDateRangeValues(dateFilterValues);
        this.onRemove = data => {
            const newValues = this.removeDateRangeFilter(data, dateFilterValues);
            this.updateState(newValues, debounce);
            debounce?.next();
        };
        this.isVisible = !!dateFilterValues;
    }

    /*  We do this because I think it's a bad idea to convert the strings to dates again
        By returning a boolean we can the use it to keep or remove the dates in the operations object
     */
    override getState(): { datesRemoved: boolean } {
        return this.values.length ? { datesRemoved: false } : { datesRemoved: true };
    }
}
